import { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import PricePredictions from './components/PricePredictions/PricePredictions';
import LanguageSwitch from './components/LanguageSwitch/LanguageSwitch';
import { isAuthenticated, logout, verifyToken, getCurrentUser } from './services/authService';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (isAuthenticated()) {
        const valid = await verifyToken();
        setAuthenticated(valid);
        if (valid) {
          setUser(getCurrentUser());
        } else {
          logout();
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const handleLoginSuccess = (userData) => {
    setAuthenticated(true);
    setUser(userData);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    logout();
    setAuthenticated(false);
    setUser(null);
    setCurrentPage('dashboard');
  };

  if (loading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: '#1a1a2e'
      }}>
        <div style={{ color: '#fff', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <LanguageSwitch />
      {authenticated ? (
        currentPage === 'price-predictions' ? (
          <PricePredictions onBack={() => setCurrentPage('dashboard')} />
        ) : (
          <Dashboard
            user={user}
            onLogout={handleLogout}
            onOpenPricePredictions={() => setCurrentPage('price-predictions')}
          />
        )
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
}

export default App;
